<template lang="pug">
  .panel-body
    .my-2
      cite Todos os autores que participaram da produção deste curso
    .divider
    .columns.mt-2.pt-2.align-center.col-gapless(v-for="author in course.authors")
      .column.col-auto
        user-avatar(:user="author")
      .column.text-ellipsis
        .ml-2.text-large.text-ellipsis {{ author.name }}
</template>

<script>
export default {
  props: { course: { type: Object, required: true } },
}
</script>
